import { Navigate, useParams } from 'react-router-dom';

/** /kiosk/:eventId/:sessionId → check-in screen locked to kiosk mode + session */
export function KioskRedirect() {
  const { eventId, sessionId } = useParams<{ eventId: string; sessionId: string }>();
  return <Navigate to={`/checkin/${eventId}?mode=kiosk&session=${sessionId}`} replace />;
}
